<div class="row do-not-print">
  <div class="col-md-12 text-right">
    <!-- MESSAGE PLACEHOLDER -->
  </div>
</div>
<div class="row do-not-print">
  <div class="col-md-12 action-btns-right">
    <button *ngIf="canSeeCode" mat-raised-button id="codeBtn" class="btn btn-primary code-abstract-btn do-not-print"
      (click)="codeAbstract()">Code Abstract</button>
    <button mat-raised-button class="btn btn-primary" onClick="window.print();return false;">Print Abstract</button>
    <button *ngIf="canSeeOverride" mat-raised-button class="btn btn-danger do-not-print"
      (click)="overrideAbstract()">{{this.overrideButtonText}}</button>
    <button *ngIf="notes && notes.length" mat-raised-button class="btn btn-primary do-not-print" (click)="openDialog()">QC Notes ({{notes.length}})</button>
    <!--<button *ngIf="canSeeEdit" mat-raised-button class="do-not-print" (click)="setEdit()">Edit Abstract</button>-->
    <ng-container *ngIf="canSeeReadOnlyFlags">
      <div *ngIf="abstract.hasAdjudicationFlag" class="readonly-info">
        <mat-icon class="sm-icon">check</mat-icon> Request for ODP Adjudication
      </div>
      <div *ngIf="abstract.hasCoderQuestionFlag" class="readonly-info">
        <mat-icon class="sm-icon">check</mat-icon> QC Coder Question
      </div>
    </ng-container> 
  </div>
</div>
<div *ngIf="!readOnly && abstract && abstract.submissions && abstract.submissions.length > 0" class="do-not-print">
  <mat-card class="odp-text-abstract-subheader col-md-3">Submissions:</mat-card>
  <br />
  <div *ngFor="let sub of this.submissionLinks;">
    <button class="btn btn-link" [routerLink]="['/evaluation/view/',sub.id]">
      {{sub.title}}
    </button>
    <span class="submission-date">({{sub.dateString}})</span>
  </div>
</div>
<mat-card class="odp-text-abstract-subheader col-md-3">Abstract Details:</mat-card>
<br />
<div class="row do-not-print" *ngIf="abstract">
  <div class="col-md-12 odp-col-padding">
    <p><b>Abstract {{abstract.groupIndex}} in group of {{abstract.groupCount}}</b></p>
    <p><b>User:</b> {{fullName}}</p>
    <p><b>Date Modified:</b> {{abstract.lastModifiedDate | date}}</p>
    <p><b>Project Title: </b><span class="title-text"> {{abstract.projectTitle}}</span></p>
    <p><b>Administering IC:</b> {{abstract.administeringIC}}</p>
    <p><b>Application ID:</b> {{abstract.application}}</p>
    <p><b>PI Project Leader:</b> {{abstract.piProjectLeader}}</p>
    <p><b>FY:</b> {{abstract.fy}}</p>
    <p><b>Project Number:</b> {{abstract.projectNumber}}</p>
  </div>
</div>

<div class="odp-hide-element print" *ngIf="abstract">
  <div class="row">
    <div class="col-md-3">
      <span><b>User:</b> {{fullName}}</span>
    </div>
    <div class="col-md-3">
      <span><b>Date Modified:</b> {{abstract.lastModifiedDate | date}}</span>
    </div>
    <div class="col-md-2">
      <span><b>FY:</b> {{abstract.fy}}</span>
    </div>
    <div class="col-md-4">
      <span><b>Administering IC:</b> {{abstract.administeringIC}}</span>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <span><b>Project Title:</b> {{abstract.projectTitle}}</span>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4">
      <span><b>PI Project Leader:</b> {{abstract.piProjectLeader}}</span>
    </div>
    <div class="col-md-4">
      <span><b>Project Number:</b> {{abstract.projectNumber}}</span>
    </div>
    <div class="col-md-6">
      <span><b>Application ID:</b> {{abstract.application}}</span>
    </div>
  </div>
</div>

<mat-card class="odp-text-abstract-subheader col-md-3">Description:</mat-card>
<br />
<div class="row" *ngIf="abstract?.abstractText">
  <div class="col-md-12">
    <p>{{abstract.abstractText.descPart}}</p>
  </div>
</div>
<mat-card class="odp-text-abstract-subheader col-md-3">Public Health Relevance:</mat-card>
<br />
<div class="row" *ngIf="abstract?.abstractText">
  <div class="col-md-12">
    <p>{{abstract.abstractText.publicHealthPart}}</p>
  </div>
</div>
